import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2003"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M.694 4.759h14.601a.7.7 0 1 0 0-1.4H.694a.7.7 0 1 0 0 1.4zM15.295 7.16H.694a.7.7 0 1 0 0 1.4h14.601a.7.7 0 1 0 0-1.4zm0 3.801H.694a.7.7 0 1 0 0 1.4h14.601a.7.7 0 1 0 0-1.4z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }